import { render } from "./PpcSbBudgetAllocationHeader.vue?vue&type=template&id=7ebdbe76&scoped=true"
import script from "./PpcSbBudgetAllocationHeader.vue?vue&type=script&lang=js"
export * from "./PpcSbBudgetAllocationHeader.vue?vue&type=script&lang=js"

import "./PpcSbBudgetAllocationHeader.vue?vue&type=style&index=0&id=7ebdbe76&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ebdbe76"]])

export default __exports__